import { l } from '@manychat/manyui'

export enum ExternalTriggerType {
  HOTMART_ABANDONED_CART = 'hotmart_abandoned_cart',
  HOTMART_POST_PURCHASE_CHANGE_STATUS = 'hotmart_purchase_change_status',
  TIKTOK_ADS_CTX = 'tiktok_ads_ctx',
}

export enum ExternalTriggerStatusType {
  INITIAL = 'initial',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DELETED = 'deleted',
}

export const ExternalAppContext = 'app'
export const AppLocalContext = 'lcf'

export enum HotmartPostPurchaseStatus {
  PURCHASE_COMPLETE = 'PURCHASE_COMPLETE',
  PURCHASE_APPROVED = 'PURCHASE_APPROVED',
  PURCHASE_EXPIRED = 'PURCHASE_EXPIRED',
  PURCHASE_PROTEST = 'PURCHASE_PROTEST',
  PURCHASE_DELAYED = 'PURCHASE_DELAYED',
  PURCHASE_REFUNDED = 'PURCHASE_REFUNDED',
  PURCHASE_CHARGEBACK = 'PURCHASE_CHARGEBACK',
  PURCHASE_BILLET_PRINTED = 'PURCHASE_BILLET_PRINTED',
  PURCHASE_CANCELED = 'PURCHASE_CANCELED',
}

export const HotmartPostPurchaseStatusLabels = {
  [HotmartPostPurchaseStatus.PURCHASE_COMPLETE]: l.makeTranslate('Purchase completed'),
  [HotmartPostPurchaseStatus.PURCHASE_APPROVED]: l.makeTranslate('Purchase approved'),
  [HotmartPostPurchaseStatus.PURCHASE_EXPIRED]: l.makeTranslate('Payment expired'),
  [HotmartPostPurchaseStatus.PURCHASE_PROTEST]: l.makeTranslate('Refund requested'),
  [HotmartPostPurchaseStatus.PURCHASE_DELAYED]: l.makeTranslate('Payment overdue'),
  [HotmartPostPurchaseStatus.PURCHASE_REFUNDED]: l.makeTranslate('Refund issued'),
  [HotmartPostPurchaseStatus.PURCHASE_CHARGEBACK]: l.makeTranslate('Payment chargeback'),
  [HotmartPostPurchaseStatus.PURCHASE_BILLET_PRINTED]: l.makeTranslate('Payment pending'),
  [HotmartPostPurchaseStatus.PURCHASE_CANCELED]: l.makeTranslate('Payment canceled'),
}

export enum HotmartPurchaseProductCondition {
  ANY = 'any',
  SPECIFIC = 'specific',
}

export enum HotmartPurchaseProductFormat {
  EBOOK = 'EBOOK',
  SOFTWARE = 'SOFTWARE',
  MOBILE_APPS = 'MOBILE_APPS',
  VIDEOS = 'VIDEOS',
  AUDIOS = 'AUDIOS',
  TEMPLATES = 'TEMPLATES',
  IMAGES = 'IMAGES',
  ONLINE_COURSE = 'ONLINE_COURSE',
  SERIAL_CODES = 'SERIAL_CODES',
  ETICKET = 'ETICKET',
  ONLINE_SERVICE = 'ONLINE_SERVICE',
  ONLINE_EVENT = 'ONLINE_EVENT',
  BUNDLE = 'BUNDLE',
  COMMUNITY = 'COMMUNITY',
}

export const HotmartPurchaseProductFormatLabels = {
  [HotmartPurchaseProductFormat.EBOOK]: l.makeTranslate('Ebook'),
  [HotmartPurchaseProductFormat.SOFTWARE]: l.makeTranslate('Software'),
  [HotmartPurchaseProductFormat.MOBILE_APPS]: l.makeTranslate('Mobile app'),
  [HotmartPurchaseProductFormat.VIDEOS]: l.makeTranslate('Videos'),
  [HotmartPurchaseProductFormat.AUDIOS]: l.makeTranslate('Audios'),
  [HotmartPurchaseProductFormat.TEMPLATES]: l.makeTranslate('Templates'),
  [HotmartPurchaseProductFormat.IMAGES]: l.makeTranslate('Images'),
  [HotmartPurchaseProductFormat.ONLINE_COURSE]: l.makeTranslate('Online course'),
  [HotmartPurchaseProductFormat.SERIAL_CODES]: l.makeTranslate('Serial codes'),
  [HotmartPurchaseProductFormat.ETICKET]: l.makeTranslate('E-ticket'),
  [HotmartPurchaseProductFormat.ONLINE_SERVICE]: l.makeTranslate('Online service'),
  [HotmartPurchaseProductFormat.ONLINE_EVENT]: l.makeTranslate('Online event'),
  [HotmartPurchaseProductFormat.BUNDLE]: l.makeTranslate('Bundle'),
  [HotmartPurchaseProductFormat.COMMUNITY]: l.makeTranslate('Community'),
} as const
